import { GeocodedAddressData } from '@/shared/components/AddressAutocomplete';
import AddressAutocomplete from '@/shared/components/AddressAutocomplete';

/**
 * Feature 060: Simplified to location input only
 * Removed serviceRanges and radius controls
 */
type LocationStepProps = {
  selectedAddress: string;
  setSelectedAddress: (address: string) => void;
  onAddressSelectAndGeocode: (data: GeocodedAddressData) => void;
  addressResetTrigger: number;
  selectedState: string;
  selectedCounty: string;
  selectedZipCode: string;
};

export const LocationStep = ({
  selectedAddress,
  setSelectedAddress,
  onAddressSelectAndGeocode,
  addressResetTrigger,
  selectedState,
  selectedCounty,
  selectedZipCode,
}: LocationStepProps) => {
  return (
    <div>
      <h3 className="text-base sm:text-lg font-termina font-semibold text-[#111827] mb-4 sm:mb-6">
        What's the client's zip code?
      </h3>
      <div className="mb-6">
        <div className="w-full [&_input]:!rounded-lg [&_input]:!border [&_input]:!border-[#026857] [&_input]:!bg-white [&_input]:!px-4 [&_input]:!py-3 [&_input]:!text-sm [&_input]:!font-termina [&_input]:!text-[#111827] [&_input]:placeholder:!text-[#A3A7B5] [&_input]:focus:!border-[#026857] [&_input]:focus:!outline-none [&_input]:focus:!ring-2 [&_input]:focus:!ring-[#026857]/20">
          <AddressAutocomplete
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            onAddressSelectAndGeocode={onAddressSelectAndGeocode}
            resetTrigger={addressResetTrigger}
          />
        </div>
      </div>

      {(selectedState || selectedCounty || selectedZipCode) && (
        <div className="flex flex-wrap gap-2 mb-4">
          {selectedState && (
            <span className="rounded-full px-4 py-2 text-sm font-termina bg-[#026857]/10 text-[#026857] border border-[#026857]">
              State: {selectedState}
            </span>
          )}
          {selectedCounty && (
            <span className="rounded-full px-4 py-2 text-sm font-termina bg-[#026857]/10 text-[#026857] border border-[#026857]">
              County: {selectedCounty}
            </span>
          )}
          {selectedZipCode && (
            <span className="rounded-full px-4 py-2 text-sm font-termina bg-[#026857]/10 text-[#026857] border border-[#026857]">
              ZIP: {selectedZipCode}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

